// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import LevelTile from "../prefabs/LevelTile";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
import EarnedPointsTotal from "../prefabs/EarnedPointsTotal";
import BtnBack from "../core/prefabs/BtnBack";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnAudio from "../core/prefabs/BtnAudio";
import TaxiCard from "../prefabs/TaxiCard";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { SceneData, TransitionPoint } from '../app-routing';
import UIButton from '../core/components/UIButton';
import { GameDataHandler } from '../GameDataHandler';
import { CharacterName, CharacterNameValues } from '../Character';
import { LevelNameValues, LevelState } from '../level/levels/level';
import { LevelPurchaseDetails } from './../level/levels/level';
/* END-USER-IMPORTS */

export default class LevelSelect extends BaseScene {

  constructor() {
    super("LevelSelect");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    this.add.image(960, 384, "level-select", "bg-levelselect.png");

    // Card
    const card = this.add.container(0, 0);

    // bgPaper
    const bgPaper = this.add.image(960, 460, "level-select", "paper.png");
    card.add(bgPaper);

    // level1
    const level1 = new LevelTile(this, 724, 332);
    card.add(level1);

    // level2
    const level2 = new LevelTile(this, 960, 333);
    card.add(level2);

    // level3
    const level3 = new LevelTile(this, 1196, 332);
    card.add(level3);

    // level4
    const level4 = new LevelTile(this, 724, 504);
    card.add(level4);

    // level5
    const level5 = new LevelTile(this, 960, 504);
    card.add(level5);

    // level6
    const level6 = new LevelTile(this, 1196, 503);
    card.add(level6);

    // level7
    const level7 = new LevelTile(this, 724, 676);
    card.add(level7);

    // level8
    const level8 = new LevelTile(this, 960, 676);
    card.add(level8);

    // level9
    const level9 = new LevelTile(this, 1196, 676);
    card.add(level9);

    // titleText
    const titleText = this.add.text(960, 217, "", {});
    titleText.setOrigin(0.5, 0.5);
    titleText.visible = false;
    titleText.text = "Pickup Schedule";
    titleText.setStyle({ "color": "#b29a5e", "fontFamily": "FREDFREDBURGERHEADLINE-BLACK ", "fontSize": "42px" });
    card.add(titleText);

    // earnedPointsTotal
    const earnedPointsTotal = new EarnedPointsTotal(this, 960, 80);
    this.add.existing(earnedPointsTotal);
    earnedPointsTotal.visible = false;

    // btnBack
    const btnBack = new BtnBack(this, 84, 84);
    this.add.existing(btnBack);

    // btnAudio
    const btnAudio = new BtnAudio(this, 1836, 84);
    this.add.existing(btnAudio);

    // taxiCard
    const taxiCard = new TaxiCard(this, 464, 301);
    this.add.existing(taxiCard);
    taxiCard.angle = -25;

    // taxiCard_1
    const taxiCard_1 = new TaxiCard(this, 1462, 555);
    this.add.existing(taxiCard_1);
    taxiCard_1.angle = -20;

    // taxiCard_2
    const taxiCard_2 = new TaxiCard(this, 467, 604);
    this.add.existing(taxiCard_2);
    taxiCard_2.angle = 10;

    // taxiCard_3
    const taxiCard_3 = new TaxiCard(this, 1472, 354);
    this.add.existing(taxiCard_3);
    taxiCard_3.angle = 30;

    // lists
    const levels = [level6, level9, level8, level7, level4, level2, level3, level5, level1];
    const taxiCards = [taxiCard, taxiCard_3, taxiCard_2, taxiCard_1];

    // level1 (prefab fields)
    level1.name = "1";
    level1.nextLevel = level2;
    level1.state = "Purchased";

    // level2 (prefab fields)
    level2.name = "2";
    level2.linkedLevel = "level2";
    level2.nextLevel = level3;

    // level3 (prefab fields)
    level3.name = "3";
    level3.linkedLevel = "level3";
    level3.nextLevel = level4;
    level3.unlockCost = 80;

    // level4 (prefab fields)
    level4.name = "4";
    level4.linkedLevel = "level4";
    level4.nextLevel = level5;
    level4.unlockCost = 100;

    // level5 (prefab fields)
    level5.name = "5";
    level5.linkedLevel = "level5";
    level5.nextLevel = level6;
    level5.unlockCost = 120;

    // level6 (prefab fields)
    level6.name = "6";
    level6.linkedLevel = "level6";
    level6.nextLevel = level7;
    level6.unlockCost = 150;

    // level7 (prefab fields)
    level7.name = "7";
    level7.linkedLevel = "level7";
    level7.nextLevel = level8;
    level7.unlockCost = 180;

    // level8 (prefab fields)
    level8.name = "8";
    level8.linkedLevel = "level8";
    level8.nextLevel = level9;
    level8.unlockCost = 200;

    // level9 (prefab fields)
    level9.name = "9";
    level9.linkedLevel = "level9";
    level9.unlockCost = 250;

    // titleText (components)
    const titleTextFitTextToBounds = new FitTextToBounds(titleText);
    titleTextFitTextToBounds.maxWidth = 320;
    titleTextFitTextToBounds.maxHeight = 60;
    titleTextFitTextToBounds.minFontSize = 20;
    titleTextFitTextToBounds.constrainByWidth = true;
    titleTextFitTextToBounds.constrainByHeight = true;
    const titleTextLocaliseText = new LocaliseText(titleText);
    titleTextLocaliseText.copyId = "levels";

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    this.card = card;
    this.level1 = level1;
    this.level2 = level2;
    this.level3 = level3;
    this.level4 = level4;
    this.level5 = level5;
    this.level6 = level6;
    this.level7 = level7;
    this.level8 = level8;
    this.level9 = level9;
    this.btnBack = btnBack;
    this.btnAudio = btnAudio;
    this.levels = levels;
    this.taxiCards = taxiCards;

    this.events.emit("scene-awake");
  }

  private card!: Phaser.GameObjects.Container;
  private level1!: LevelTile;
  private level2!: LevelTile;
  private level3!: LevelTile;
  private level4!: LevelTile;
  private level5!: LevelTile;
  private level6!: LevelTile;
  private level7!: LevelTile;
  private level8!: LevelTile;
  private level9!: LevelTile;
  private btnBack!: BtnBack;
  private btnAudio!: BtnAudio;
  private levels!: LevelTile[];
  private taxiCards!: TaxiCard[];

  /* START-USER-CODE */
  protected sceneData!: SceneData;
  private taxiCardX!: number[];
  private taxiCardY!: number[];
  private levelSelected:boolean = false;

  public init(data: SceneData): void {
    this.sceneData = data;

    super.init(data);
  }

  public create() {
    super.create();
    this.editorCreate();

    this.levelSelected = false;
    this.btnBack.once(UIButton.events.clicked, this.back, this);

    let unlockedLevels: LevelNameValues[] = this.game.registry.get(GameDataHandler.keys.UnlockedLevels);
    let justUnlockedLevels: LevelNameValues[] = this.game.registry.get(GameDataHandler.keys.JustUnlockedLevels);

    console.log(unlockedLevels, justUnlockedLevels);
    for (const level of this.levels) {
      level.on(LevelTile.events.LevelSelected, this.onLevelSelected, this);

      if (unlockedLevels.includes(level.linkedLevel)) {
        console.log(level.linkedLevel);
        level.changeState(LevelState.Unlocked);
      }
    }

    GameDataHandler.clearJustUnlockedLevels(this);

    var delay:number = 800;
    let characters = Object.values(CharacterName) as CharacterNameValues[];
    Phaser.Utils.Array.Shuffle(characters);
    for (let i = 0; i < this.taxiCards.length; i++) {
      const taxiCard = this.taxiCards[i];
      taxiCard.changeOwner(characters[i]);

      let tx = taxiCard.x;
      let ty = taxiCard.y;
      let tr = taxiCard.angle;
      if(i==0){
        taxiCard.x -= 1000;
        taxiCard.y -= 100;
        taxiCard.angle = 50;
      }
      else if(i==1){
        taxiCard.x += 1000;
        taxiCard.y -= 100;
        taxiCard.angle = 20;
      }
      else if(i==2){
        taxiCard.x -= 1000;
        taxiCard.y += 100;
        taxiCard.angle = 40;
      }
      else if(i==3){
        taxiCard.x += 1000;
        taxiCard.y += 100;
        taxiCard.angle = 60;
      }
      this.add.tween({
        targets: [taxiCard],
        x: tx,
        y: ty,
        angle: tr,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: delay
      });
      delay+=100;
    }

    this.card.y += 800;
    this.card.angle = 15;
    this.add.tween({
      targets: [this.card],
      y: 0,
      angle: 0,
      duration: 1000,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 300
    });
  }

  public back() {
    app.gotoNextScene(this, TransitionPoint.LevelSelectBack);
  }

  protected onLevelSelected(selectedLevelTile: LevelTile) {
    if(this.levelSelected)
    {
      return;
    }
    this.levelSelected = true;
    if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
    this.sceneData.runSettings.selectedLevel = selectedLevelTile.linkedLevel;

    // Extract all the level data from the levelTiles for use later.
    let levelPurchaseData: Partial<Record<LevelNameValues, LevelPurchaseDetails>> = {};
    for (let i = 0; i < this.levels.length; i++) {
      const level = this.levels[i];
      levelPurchaseData[level.linkedLevel] = {
        linkedLevel: level.linkedLevel,
        price: level.unlockCost,
        nextLevel: level.nextLevel?.linkedLevel,
        nextLevelPrice: level.nextLevel?.unlockCost
      };
    }

    this.sceneData.runSettings.levelPurchaseDetails = levelPurchaseData as Record<LevelNameValues, LevelPurchaseDetails>;

    app.gotoNextScene(this, TransitionPoint.LevelSelectEnd, this.sceneData);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
